import React, { Suspense, lazy } from "react";
import { LazyMotion, domAnimation } from "framer-motion";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PortfolioLayout from "./pages/PortfolioLayout";

// Separate chunk so visitors to the portfolio don't download the landing page.
const RealEstateGrowth = lazy(() => import("./pages/real-estate-growth/RealEstateGrowth"));

function App() {
  return (
    <LazyMotion features={domAnimation} strict>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PortfolioLayout />} />
          <Route
            path="/real-estate-ai-growth-system"
            element={
              <Suspense fallback={null}>
                <RealEstateGrowth />
              </Suspense>
            }
          />
        </Routes>
      </BrowserRouter>
    </LazyMotion>
  );
}

export default App;
